<div class="layout-breadcrumb-container">
    <nav class="layout-breadcrumb">
        <ol>
            <ng-template ngFor let-item let-first="first" let-last="last" [ngForOf]="breadcrumbs$ | async">
                <li *ngIf="first"><i class="{{item.icon}}"></i></li>
                <li *ngIf="!first"><i class="pi pi-angle-right"></i></li>
                <li [ngClass]="{'breadcrumb-item': !first, 'cursor-pointer': !first}"
                    (click)="onRedirct(item.url, first)">
                    <span>{{translation_service.getText(item.language_key)}}</span>
                </li>
            </ng-template>
        </ol>
    </nav>
    <div class="layout-breadcrumb-buttons">
        <p-splitButton [model]="stateOptions" label="+ Create" optionLabel="label" optionValue="value" aria-labelledby="basic" />
    </div>
</div>

<p-sidebar [(visible)]="visible" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'">
    <ng-container *ngIf="showTimesheetComponent">
        <app-job-timesheet [triggerApi]="triggerApi" (onClose)="handleClose($event)"></app-job-timesheet>
    </ng-container>

    <ng-container *ngIf="showExpenseComponent">
        <app-job-expense [triggerApi]="triggerApi" (onClose)="handleClose($event)"></app-job-expense>
    </ng-container>
</p-sidebar>